import { useReveal } from '../hooks/useReveal';

/**
 * <Reveal delay={0.1}>
 *   <YourContent />
 * </Reveal>
 *
 * Wraps any content with a smooth fade-up reveal on scroll.
 */
export default function Reveal({ children, delay = 0, style = {} }) {
  const { ref, visible } = useReveal();

  return (
    <div
      ref={ref}
      style={{
        opacity:    visible ? 1 : 0,
        transform:  visible ? 'none' : 'translateY(28px)',
        transition: `opacity 0.7s ${delay}s ease, transform 0.7s ${delay}s ease`,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
